import React from 'react';
import '../App.css';
import { Zap, Shield, Clock, Search, Database, Network, Filter , Send } from 'lucide-react';

function AlgoheadsGetStartedSection() {
  return (
    <div className="algo-get-started-container">
      <h2 className="algo-section-title">How it Works</h2>
      
      <div className="algo-cards-container">
        <div className="algo-card algo-small-card">
          <div className="algo-card-content">
            <h3 className="algo-card-title">How AlgoHeads Works</h3>
            <ol className="algo-steps-list">
              <li className="algo-step">
                <span className="algo-step-highlight">Connect:</span> Upload your LinkedIn connections (CSV) to feed our AI with your professional network data.
              </li>
              <li className="algo-step">
                <span className="algo-step-highlight">Process:</span> Our algorithms extract company information and build an optimized index of your connections.
              </li>
              <li className="algo-step">
                <span className="algo-step-highlight">Match:</span> AI-driven system scrapes 5+ job boards in 70+ countries and matches opportunities with your network. 🔍
              </li>
            </ol>
          </div>
        </div>
        
        <div className="algo-card algo-small-card">
          <div className="algo-card-content">
            <div className="algo-feature">
              <Search className="algo-feature-icon" />
              <h4 className="algo-feature-title">Not Another LinkedIn</h4>
              <p className="algo-feature-desc">Unlike LinkedIn, AlgoHeads scrapes jobs only from companies where your connections already work—flipping the traditional job search.</p>
              </div>
            
            <div className="algo-feature">
              <Filter className="algo-feature-icon" />
              <h4 className="algo-feature-title">Early Application Advantage</h4>
              <p className="algo-feature-desc">Only scrapes jobs posted in the last 2-3 days, ensuring you're among the first applicants when recruiters are most active</p>
              </div>

              
          </div>
        </div>
        
        <div className="algo-card algo-large-card">
          <div className="algo-card-content algo-large-card-content">
            <div className="algo-feature-row">
              <div className="algo-feature">
                <Shield className="algo-feature-icon" />
                <h4 className="algo-feature-title">Privacy First</h4>
                <p className="algo-feature-desc">Your data is processed locally and never stored on our servers</p>
              </div>
              
              <div className="algo-feature">
                <Database className="algo-feature-icon" />
                <h4 className="algo-feature-title">Optimized Indexing</h4>
                <p className="algo-feature-desc">Efficient database architecture for lightning-fast results</p>
              </div>
              
              <div className="algo-feature">
                <Network className="algo-feature-icon" />
                <h4 className="algo-feature-title">Connection Details</h4>
                <p className="algo-feature-desc">Direct links to apply and leverage connections for referrals</p>
              </div>
              
              <div className="algo-feature">
                <Send  className="algo-feature-icon" />
                <h4 className="algo-feature-title">Ready-to-Send Referrals</h4>
                <p className="algo-feature-desc">Get ready-to-send referral messages tailored to each connection.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlgoheadsGetStartedSection;